<script>
	import { onMount, createEventDispatcher } from "svelte";
	import { SupportUser,Response,isFormAlreadySubmitted } from "./store.js";
	import Steps from "./steps.svelte";
	import wrappedFetch from "../../wrappedFetch.js";
	let content;
    let isPageLoading = true;
    let showFooterButtons=true;
	const dispatch = new createEventDispatcher();
	const getContent = async () => {
		const getHelpContents = await wrappedFetch(
			"helpcontent?helpId=furtherfeedback"
		);
		let resp = await getHelpContents.json();
		return resp.filter((r) => r.type == "h2")[0].text;
	};

	const gotoNext = () => {
     
           // _paq.push(['trackEvent', 'SupportForm', `Signed in Next`]);
           $Response.step1 = true;
            dispatch("pageChange", "/furtherfeedback/step2");
    
    };
	onMount(async () => {
       
        if(!isFormAlreadySubmitted())
            content = await getContent();
            else 
            {
                content ='<p>We have received your query and will respond shortly. If you need to submit a different query, please try again later.</p>'
                showFooterButtons = false;
                dispatch("checkCookie");
            }
		isPageLoading = false;
	});
</script>

<Steps	
	buttonText={"Next"}
    bind:isPageLoading
    bind:showFooterButtons   
    on:handleNext={gotoNext}  
    backUrl={"/help"}
	on:pageChange={(event) => dispatch('pageChange', event.detail)}>
    <div class="column">{@html content}</div>
</Steps>
